var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.template)?_c('div',{staticClass:"instype-result-wrap"},[_c('fast-liability',{attrs:{"temp":_vm.template,"data":_vm.descData,"profit-btn":_vm.propProfit,"company-list":_vm.companyList},on:{"disShow":_vm._fetchDisData}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }